/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable computed-property-spacing */
/* eslint-disable array-bracket-spacing */
import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from 'react-bootstrap/ModalHeader';
import ModalTitle from 'react-bootstrap/ModalTitle';
import ModalBody from 'react-bootstrap/ModalBody';
import ModalFooter from 'react-bootstrap/ModalFooter';
import API from '../../../../src/apiService';

const dataSchema = Yup.object().shape({
  counseling_problem: Yup.string().required('Kondisi/Masalah harus diisi'),
  counseling_suggestion: Yup.string().required('Saran/Rekomendasi harus diisi'),
  inspection_date: Yup.date().required('Tanggal Inspeksi harus diisi'),
  inspection_result: Yup.string().required('Hasil Inspeksi harus diisi'),
  inspection_intervention: Yup.string().required('Intervensi harus diisi'),
  description: Yup.string().required('Keterangan harus diisi'),
});

export default class modalAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: null,
        visit_id: this.props.data && this.props.data.visit_id,
        counseling_problem: '',
        counseling_suggestion: '',
        inspection_date: moment().format('YYYY-MM-DD'),
        inspection_result: '',
        inspection_intervention: '',
        description: '',
      },
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.data !== this.props.data) this.setState({ data: this.props.data });
  }

  onChange = e => {
    const value = e.target.value;
    const object = e.target.name;

    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [object]: value
      }
    }));
  };

  handleSubmit = async () => {
    const { data } = this.state;
    if (data.id) this.putData();
    else this.postData();
  };

  resetData = () => {
    this.setState({
      data: {
        id: null,
        visit_id: null,
        counseling_problem: '',
        counseling_suggestion: '',
        inspection_date: moment().format('YYYY-MM-DD'),
        inspection_result: '',
        inspection_intervention: '',
        description: '',
      }
    });
  }

  postData = async () => {
    const { onHide } = this.props;
    const { data } = this.state;
    const res = await API.post('registration/kesling/create', data);
    if (res.code === 200) {
      onHide();
      this.resetData();
    }
  };

  putData = async () => {
    const { onHide } = this.props;
    const { data } = this.state;
    const res = await API.put('registration/kesling/update', data);
    if (res.code === 200) {
      onHide();
      this.resetData();
    }
  };

  render() {
    const { data } = this.state;
    const { onHide } = this.props;
    return (
      <Modal
        size='lg'
        aria-labelledby="modal-data"
        onHide={() => {
          onHide();
          this.resetData();
        }}
      >
        <ModalHeader closeButton>
          <ModalTitle>
            <h3>Tambah Data Status Kesehatan Lingkungan</h3>
          </ModalTitle>
        </ModalHeader>
        <Formik
          enableReinitialize
          initialValues={{
            counseling_problem: data && data.counseling_problem,
            counseling_suggestion: data && data.counseling_suggestion,
            inspection_date: data && data.inspection_date,
            inspection_result: data && data.inspection_result,
            inspection_intervention: data && data.inspection_intervention,
            description: data && data.description
          }}
          validationSchema={dataSchema}
          onSubmit={() => {
            this.handleSubmit();
          }}
        >
          {({ values, errors, touched }) => (
            <Form>
              <ModalBody>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Kondisi/Masalah
                  </label>
                  <div className='input-group'>
                    <input
                      type='text'
                      id="counseling_problem"
                      name="counseling_problem"
                      onChange={this.onChange}
                      className='form-control'
                      value={values.counseling_problem}
                    />
                  </div>
                  {errors.counseling_problem && touched.counseling_problem && <div className='text-sm text-danger'>{errors.counseling_problem}</div>}
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Saran/Rekomendasi
                  </label>
                  <div className='input-group'>
                    <input
                      type='text'
                      id="counseling_suggestion"
                      name="counseling_suggestion"
                      onChange={this.onChange}
                      className='form-control'
                      value={values.counseling_suggestion}
                    />
                  </div>
                  {errors.counseling_suggestion && touched.counseling_suggestion && <div className='text-sm text-danger'>{errors.counseling_suggestion}</div>}
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Tanggal Inspeksi
                  </label>
                  <div className='input-group'>
                    <input
                      type='date'
                      id="inspection_date"
                      name="inspection_date"
                      onChange={this.onChange}
                      className='form-control'
                      value={values.inspection_date}
                    />
                  </div>
                  {errors.inspection_date && touched.inspection_date && <div className='text-sm text-danger'>{errors.inspection_date}</div>}
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Hasil Inspeksi
                  </label>
                  <div className='input-group'>
                    <input
                      type='text'
                      id="inspection_result"
                      name="inspection_result"
                      onChange={this.onChange}
                      className='form-control'
                      value={values.inspection_result}
                    />
                  </div>
                  {errors.inspection_result && touched.inspection_result && <div className='text-sm text-danger'>{errors.inspection_result}</div>}
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Intervensi
                  </label>
                  <div className='input-group'>
                    <input
                      type='text'
                      id="inspection_intervention"
                      name="inspection_intervention"
                      onChange={this.onChange}
                      className='form-control'
                      value={values.inspection_intervention}
                    />
                  </div>
                  {errors.inspection_intervention && touched.inspection_intervention && <div className='text-sm text-danger'>{errors.inspection_intervention}</div>}
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>
                    Keterangan
                  </label>
                  <div className='input-group'>
                    <input
                      type='text'
                      id="description"
                      name="description"
                      onChange={this.onChange}
                      className='form-control'
                      value={values.description}
                    />
                  </div>
                  {errors.description && touched.description && <div className='text-sm text-danger'>{errors.description}</div>}
                </div>
              </ModalBody>
              <ModalFooter>
                <button
                  type="button"
                  onClick={() => {
                    onHide();
                    this.resetData();
                  }}
                  className="btn btn-outline-secondary"
                >
                  Batal
                </button>
                <button type="submit" className="btn btn-primary">
                  Simpan Data
                </button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    );
  }
}
